import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SpinnerBlock from 'components/others/SpinnerBlock';
import HistoryPriceTableBody from './HistoryPriceTableBody';
import type { HistoryPriceRow } from './model';

interface HistoryPriceTableProps {
    rows: HistoryPriceRow[];
    loading: boolean;
    isUahMode: boolean;
}

const HistoryPriceTable = ({ rows, loading, isUahMode }: HistoryPriceTableProps) => {
    const { t } = useTranslation(['Objects']);

    return (
        <div className="position-relative">
            <SpinnerBlock onlyBlur={true} show={loading} />
            <div className="crm-table-wrap history-price-table-wrap">
                <Table className="HistoryPriceTable table-hover mb-0">
                    <thead>
                        <tr className="bg-light">
                            <td className="head-username">{t('historyPrice.cols.user')}</td>
                            <td className="head-date">{t('historyPrice.cols.date')}</td>
                            <td className="head-change">{t('historyPrice.cols.change')}</td>
                            <td className="head-comment">{t('historyPrice.cols.comment')}</td>
                        </tr>
                    </thead>
                    <HistoryPriceTableBody
                        rows={rows}
                        loading={loading}
                        isUahMode={isUahMode}
                    />
                </Table>
            </div>
        </div>
    );
};

export default HistoryPriceTable;
